var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96133 0.34375L7.37223 1.76127L4.10199 5.01624L17.707 5.02993L17.705 7.02993L4.13726 7.01627L7.35241 10.2465L5.93489 11.6574L0.291252 5.98735L5.96133 0.34375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96133 0.34375L7.37223 1.76127L4.10199 5.01624L17.707 5.02993L17.705 7.02993L4.13726 7.01627L7.35241 10.2465L5.93489 11.6574L0.291252 5.98735L5.96133 0.34375Z",
    fill: "url(#paint0_linear_812_1282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_812_1282",
    x1: 9.53228,
    y1: 0.34375,
    x2: 3.69507,
    y2: 8.56401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#390EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9244F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.d92f5d078e5c681df9a273389b68fadb.svg";
export { ForwardRef as ReactComponent };